import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ec6d73a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Breadcrumb" }
const _hoisted_2 = {
  ref: "nav",
  class: "Nav",
  "aria-label": "Brødkrumme"
}
const _hoisted_3 = { class: "SubNav" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  ref: "shadowNav",
  class: "Nav IsShadowNav",
  "aria-hidden": ""
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "Link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSVG = _resolveComponent("InlineSVG")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Backdrop = _resolveComponent("Backdrop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, { to: { name: 'ProjectRoot' } }, {
        default: _withCtx(() => [
          _createVNode(_component_InlineSVG, {
            class: "Home ButtonIcon",
            src: require('@/assets/svg/house.svg')
          }, null, 8, ["src"])
        ]),
        _: 1
      }),
      (_ctx.path.length > 1)
        ? (_openBlock(), _createBlock(_component_InlineSVG, {
            key: 0,
            class: "Icon",
            src: require('@/assets/svg/angle-right.svg')
          }, null, 8, ["src"]))
        : _createCommentVNode("", true),
      (_ctx.limitPath)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.states.subNavIsVisible)
              ? (_openBlock(), _createBlock(_component_Backdrop, {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSubNav()))
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: _normalizeClass(["SubNavToggle", { 'IsActive': _ctx.states.subNavIsVisible}]),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSubNav && _ctx.toggleSubNav(...args)))
              }, _hoisted_5, 2),
              _createElementVNode("ol", {
                class: _normalizeClass(["SubNavList", { 'IsHidden': !_ctx.states.subNavIsVisible}])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subpath, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.url
                  }, [
                    _createVNode(_component_InlineSVG, {
                      class: "Icon",
                      src: require('@/assets/svg/angle-right.svg')
                    }, null, 8, ["src"]),
                    _createVNode(_component_router_link, {
                      to: item.url,
                      class: "Link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.translation), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ], 2)
            ]),
            _createVNode(_component_InlineSVG, {
              class: "Icon",
              src: require('@/assets/svg/angle-right.svg')
            }, null, 8, ["src"])
          ], 64))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.subpath, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.url
            }, [
              _createVNode(_component_router_link, {
                to: item.url,
                class: "Link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.translation), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              (index < _ctx.path.length - 1)
                ? (_openBlock(), _createBlock(_component_InlineSVG, {
                    key: 0,
                    class: "Icon",
                    src: require('@/assets/svg/angle-right.svg')
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
      (_ctx.last)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 3,
            to: _ctx.last.url,
            class: "Link"
          }, {
            default: _withCtx(() => [
              (_ctx.isPDF)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.last.translation) + " " + _toDisplayString(_ctx.reportScope && `(${_ctx.reportScope})`), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.last.translation), 1))
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.path, (part, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: part.url
        }, [
          (index === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _createVNode(_component_InlineSVG, {
                  class: "Home ButtonIcon",
                  src: require('@/assets/svg/house.svg')
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          (index === 0 && _ctx.path.length > 1)
            ? (_openBlock(), _createBlock(_component_InlineSVG, {
                key: 1,
                class: "Icon",
                src: require('@/assets/svg/angle-right.svg')
              }, null, 8, ["src"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(part.translation), 1),
                (index < _ctx.path.length - 1)
                  ? (_openBlock(), _createBlock(_component_InlineSVG, {
                      key: 0,
                      class: "Icon",
                      src: require('@/assets/svg/angle-right.svg')
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ], 64))
        ], 64))
      }), 128))
    ], 512)
  ]))
}